(function(){
  'use strict';

  const $ = (sel, el) => (el || document).querySelector(sel);
  const $$ = (sel, el) => Array.from((el || document).querySelectorAll(sel));

  function money(cents){
    const v = (cents/100).toFixed(2);
    return '$' + v;
  }

  // ---------- Drawer ----------
  const drawer = $('[data-cart-drawer]');
  function openDrawer(){
    if (!drawer) return;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('cg-no-scroll');
    const btn = $('[data-cart-toggle]');
    if (btn) btn.setAttribute('aria-expanded', 'true');
  }
  function closeDrawer(){
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('cg-no-scroll');
    const btn = $('[data-cart-toggle]');
    if (btn) btn.setAttribute('aria-expanded', 'false');
  }
  document.addEventListener('click', (e) => {
    const t = e.target.closest('[data-cart-toggle]');
    if (t) { e.preventDefault(); openDrawer(); return; }
    if (e.target.closest('[data-cart-close]')) { e.preventDefault(); closeDrawer(); }
  });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeDrawer(); });

  // ---------- Cart fetch / update ----------
  async function getCart(){
    const r = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
    return r.json();
  }
  async function renderCartSection(){
    // Use section render API
    try {
      const r = await fetch('/?sections=cart-drawer');
      const j = await r.json();
      if (j && j['cart-drawer']) {
        // Extract inner of [data-cart-body]
        const tmp = document.createElement('div');
        tmp.innerHTML = j['cart-drawer'];
        const newBody = tmp.querySelector('[data-cart-body]');
        const curBody = $('[data-cart-body]');
        if (newBody && curBody) curBody.innerHTML = newBody.innerHTML;
        // Also refresh cart page body if present (on /cart)
        const allBodies = $$('[data-cart-body]');
        allBodies.forEach(b => { if (b !== curBody && newBody) b.innerHTML = newBody.innerHTML; });
      }
    } catch (e) { console.warn('Cart render fallback', e); }
    const cart = await getCart();
    updateCount(cart.item_count);
  }
  function updateCount(n){
    $$('[data-cart-count]').forEach(el => {
      el.textContent = n;
      el.classList.toggle('is-hidden', n <= 0);
    });
  }

  async function addToCart(formData){
    const r = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: formData
    });
    if (!r.ok) {
      const j = await r.json().catch(() => ({}));
      throw new Error(j.description || j.message || 'Could not add to cart');
    }
    return r.json();
  }
  async function changeLine(key, quantity){
    const r = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity })
    });
    return r.json();
  }

  // ---------- Product form ----------
  const form = $('[data-product-form]');
  if (form) {
    const variantInput = form.querySelector('[data-variant-id]');
    const addBtn = form.querySelector('[data-add-btn]');
    const addLabel = form.querySelector('[data-add-label]');
    const priceEl = $('[data-price]');
    const compareEl = $('[data-compare]');
    const qtyInput = form.querySelector('[data-qty-input]');

    const variantsJson = $('[data-product-json]');
    let variants = [];
    try { variants = JSON.parse(variantsJson.textContent); } catch (e) {}

    function getSelectedOptions(){
      return $$('[data-option-input]:checked', form).map(i => i.value);
    }
    function findVariant(opts){
      return variants.find(v => {
        const arr = [v.option1, v.option2, v.option3].filter(x => x !== null && x !== undefined);
        if (arr.length !== opts.length) return false;
        return arr.every((val, i) => val === opts[i]);
      });
    }
    function updateVariant(){
      const opts = getSelectedOptions();
      let v;
      if (opts.length === 0) v = variants[0];
      else v = findVariant(opts);
      if (!v) return;
      variantInput.value = v.id;
      if (priceEl) priceEl.textContent = money(v.price);
      if (compareEl) {
        if (v.compare_at_price && v.compare_at_price > v.price) {
          compareEl.textContent = money(v.compare_at_price);
          compareEl.style.display = '';
        } else {
          compareEl.style.display = 'none';
        }
      }
      if (v.available) {
        addBtn.disabled = false;
        if (addLabel) addLabel.textContent = 'Add to bag';
      } else {
        addBtn.disabled = true;
        if (addLabel) addLabel.textContent = 'Sold out';
      }
    }
    form.addEventListener('change', (e) => {
      if (e.target.matches('[data-option-input]')) updateVariant();
    });
    updateVariant();

    form.querySelectorAll('[data-form-qty]').forEach(btn => {
      btn.addEventListener('click', () => {
        const delta = parseInt(btn.getAttribute('data-form-qty'), 10);
        const cur = parseInt(qtyInput.value, 10) || 1;
        qtyInput.value = Math.max(1, cur + delta);
      });
    });

    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      addBtn.disabled = true;
      if (addLabel) addLabel.textContent = 'Adding…';
      try {
        const fd = new FormData(form);
        await addToCart(fd);
        await renderCartSection();
        if (addLabel) addLabel.textContent = 'Added ✓';
        openDrawer();
        setTimeout(() => { if (addLabel) addLabel.textContent = 'Add to bag'; addBtn.disabled = false; }, 1200);
      } catch (err) {
        console.error(err);
        if (addLabel) addLabel.textContent = err.message || 'Try again';
        setTimeout(() => { if (addLabel) addLabel.textContent = 'Add to bag'; addBtn.disabled = false; }, 1800);
      }
    });
  }

  // ---------- Quantity updates within cart body (drawer + cart page) ----------
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-qty-change]');
    if (!btn) return;
    e.preventDefault();
    const key = btn.getAttribute('data-line-key');
    const qty = parseInt(btn.getAttribute('data-qty'), 10);
    btn.disabled = true;
    try {
      await changeLine(key, qty);
      await renderCartSection();
    } catch (err) {
      console.error(err);
    } finally {
      btn.disabled = false;
    }
  });

  // ---------- Product gallery ----------
  const gal = $('[data-gallery]');
  if (gal) {
    const slides = $$('.cg-gallery-slide', gal);
    const thumbs = $$('[data-thumb]', gal);
    function show(idx){
      slides.forEach((s, i) => s.classList.toggle('is-active', i === idx));
      thumbs.forEach((t, i) => {
        t.classList.toggle('is-active', i === idx);
        t.setAttribute('aria-selected', i === idx ? 'true' : 'false');
      });
    }
    thumbs.forEach(t => t.addEventListener('click', () => show(parseInt(t.getAttribute('data-thumb'), 10))));
    slides.forEach((s, i) => s.addEventListener('click', () => {
      // Cycle to next on click
      show((i + 1) % slides.length);
    }));
  }

  // ---------- Initial count sync ----------
  getCart().then(c => updateCount(c.item_count)).catch(() => {});
})();
